<template>
  <div class="layout-title bb1" :style="style">
    <p class="p">
      <AIcon :type="icon" /> {{name}}
    </p>
    <div class="right">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: 'appstore'
    },
    name: {
      type: String,
      default: '标题'
    },
    color: {
      type: String,
      default: '#42cdb8'
    }
  },
  data() {
    return {
    };
  },
  computed:{
    style(){
      return {
        color: this.color
      }
    }
  },
  mounted(){
  },
  methods:{
  }
};
</script>
<style lang="less" scoped>
.layout-title{
  padding: 5px 0;
  margin-bottom: 8px;
  font-weight: 500;
  display: flex;
  align-items: center;
  p{
    font-size: 24px;
  }
  .right{
    margin-left: auto;
  }
}
</style>
